import { FC, useCallback } from "react";
import { twMerge } from "tailwind-merge";

import { ArrowDownIcon } from "../icons";

import { Button } from "./Button";
import { type ButtonKind } from "./ButtonKinds";

import { t } from "i18n/i18n";
import { toastErrorMessage } from "utils/alerts";
import { CSVData, downloadCSVFile, formatCSVFilename } from "utils/file";

type DownloadCSVButtonProps = {
  title: string;
  csvData: CSVData | (() => Promise<CSVData>);
  text?: string;
  kind?: ButtonKind;
  className?: string;
};

export const DownloadCSVButton: FC<DownloadCSVButtonProps> = ({
  title,
  csvData,
  text,
  kind = "transparentSquareLegacy",
  className,
}) => {
  const handleClick = useCallback(async () => {
    try {
      const resolvedCsvData = typeof csvData === "object" ? csvData : await csvData();
      downloadCSVFile(resolvedCsvData, formatCSVFilename(title));
    } catch {
      toastErrorMessage(t("assessment_summary_report.export_failed"));
    }
  }, [csvData, title]);

  return (
    <Button
      className={twMerge("h6 gap-2", className)}
      kind={kind}
      size="s"
      title="Download CSV"
      onClick={handleClick}
    >
      {text && <div>{text}</div>}
      <ArrowDownIcon />
    </Button>
  );
};
